import React from "react";

function DTOActionRequired() {
  return <></>;
}
export default DTOActionRequired;
